<template>
  <div>
    <el-row class="header">
      <el-col :span="24">
        <el-col :span="10" class="logo" @click.native="toHome">广东为众六类场所电气防火安全检测数据综合管理系统</el-col>
        <div class="userinfo">
          <el-dropdown trigger="hover">
            <div class="navName">{{ setEmployeeName() }}</div>
            <el-dropdown-menu v-slot="dropdown">
              <el-dropdown-item divided @click.native="toPasswd">
                <i class="fa fa-unlock-alt" style="width:18px; height:18px; margin-bottom:-5px;"></i>修改密码
              </el-dropdown-item>
              <el-dropdown-item divided @click.native="logout">
                <i class="fa fa-sign-out" style="width:18px; height:18px; margin-bottom:-5px;"></i> 退出登陆
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      hasUnread: true,
    };
  },
  methods: {
    toHome() {
      this.$router.push({name: "home"});
    },
    logout: function () {
      this.$store.dispatch("clearinfo");
    },
    toPasswd() {
      this.$router.push({name: "user.password"});
    },
    setEmployeeName() {
      return this.$store.state.userinfo.employee_name;
    },
  },
  created() {
  },
};
</script>
<style scoped lang="scss">
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  height: 40px;
  line-height: 40px;
  background: var(--primary-color);
  color: #fff;
  min-width: 1000px;

  .logo {
    cursor: pointer;
    display: flex;
    align-items: center;

    img {
      height: 20px;
      margin-right: 10px;
    }

    height: 40px;
    font-size: 18px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .userinfo {
    text-align: right;
    padding-right: 15px;
    float: right;

    .userinfo-inner {
      text-align: center;
      cursor: pointer;
      color: #fff;
      width: 50px;
      display: block;
    }
  }

  .notice {
    text-align: right;
    float: right;
    margin-right: 10px;

    i {
      color: #fff;
      font-size: 18px;
      line-height: 40px;
    }

    .dropdownMenu {
      width: 400px;
    }
  }
}

.title {
  width: 100%;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin: -20px 0 5px 0;
  color: var(--primary-color);
}

.showAll {
  color: #ccc;
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  text-align: center;
}

.badge {
  font-size: 18px;
  line-height: 1;
  cursor: pointer;

  ::v-deep .el-badge__content {
    background-color: #fff;
    margin-top: 10px;
  }
}

.navName {
  float: right;
  width: 80px;
  height: 30px;
  cursor: pointer;
  text-align: center;
  line-height: 30px;
  color: white;
  font-weight: bold;
  font-size: 14px;
  transition: left 0.5s, top 0.5s;
  margin-right: 10px;
  margin-top: 5px;
  border: solid 1px $color-primary;
}
</style>
